var __jsx = React.createElement;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useState } from "react";
import { CopilotKit, useCopilotChat } from "@copilotkit/react-core";
import { CopilotSidebar, useChatContext } from "@copilotkit/react-ui";
import ChatInput from "./ChatInput";
import CustomAssistantMessage from "./CustomAssistantMessage";
import CustomUserMessage from "./CustomUserMessage";
import DraggableModal from "./DraggableModal";
import AwesomeIcon from "../AwesomeIcon";
import { faRobot, faMinus, faPlus, faXmark, faWindowRestore, faWindowMaximize } from "@fortawesome/pro-regular-svg-icons";
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import { get } from "lodash";
import NewChatModal from "./NewChatModal";
var CopilotWrapper = function CopilotWrapper(_ref) {
  var authData = _ref.authData,
    children = _ref.children;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        userInfo: s.userInfo
      };
    }),
    userInfo = _useStoreState.userInfo;
  var isEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
  return /*#__PURE__*/React.createElement(CopilotKit, {
    runtimeUrl: "/api/copilotkit",
    headers: {
      "x-ai-assistant-enabled": userInfo ? String(isEnabled) : ""
    }
  }, children, /*#__PURE__*/React.createElement(CopilotSidebar, {
    instructions: "You are assisting the user as best as you can. Answer in the best way possible given the data you have.",
    makeSystemMessage: defaultSystemMessage,
    Header: Header,
    Input: function Input(_ref2) {
      var onSend = _ref2.onSend,
        inProgress = _ref2.inProgress,
        isVisible = _ref2.isVisible;
      return /*#__PURE__*/React.createElement(ChatInput, {
        inProgress: inProgress,
        isVisible: isVisible,
        onSend: onSend,
        placeholder: "Ask Qure AI Assistant..."
      });
    },
    Window: DraggableModal,
    AssistantMessage: CustomAssistantMessage,
    UserMessage: CustomUserMessage,
    labels: {
      title: "AI Assistant",
      initial: "Welcome to **Qure AI Assistant!** I’m your personal assistant for everything within the app. I can help you with:\n\n" + "Key features\n" + "  • Adding new patients or editing patient details\n" + "  • Creating and editing patient forms\n" + "  • Retrieving detailed patient summaries\n" + "  • Searching and filtering patients\n\n" + "Other supported features\n" + "  • Sharing patient information\n" + "  • Toggling between light and dark themes\n\n" + "Try slash command `/` to view ready-made prompts you can use instantly, or try Speak mode to dictate your input hands-free."
    },
    className: "fixed bottom-0 right-0 !z-[99]"
  }));
};
function defaultSystemMessage(contextString, additionalInstructions) {
  return "\nYou are assistant, which is built by Qure to act as the AI Assistant for heathcare workers, doctors, nurse to help in managing different patient workflows according to their need\n\nPlease respond only in English. If the user inputs a message in any other language, politely inform them that you can only continue the conversation in English. Do not attempt to translate or reply in another language.\n\nYour functionality is limited by the functions provided in the tools array, so, keep conversation limited around those tools only.\nif user tries goes beyond the tools, then you can ask them to rephrase their question or answer in a way that is more likely to be handled by the tools.\nIf the user asks very general questions that go beyond the intended functionality or scope of the supported tools, politely inform them that your capabilities are limited to specific tools. Mention that you currently support only the tools, and can assist with tasks related to them only. Avoid answering unrelated or unsupported queries.\nHelp the user achieve their goals, and you do so in a way that is as efficient as possible, without unnecessary fluff, but also without sacrificing professionalism.\nAlways be polite and respectful, and prefer brevity over verbosity.\n\nThe user has provided you with the following context:\n```\n".concat(contextString, "\n```\n\nThey have also provided you with functions you can call to initiate actions on their behalf, or functions you can call to receive more information.\n\nPlease assist them as best you can.\n\nYou can ask them for clarifying questions if needed, but don't be annoying about it. If you can reasonably 'fill in the blanks' yourself, do so.\n\nIf you would like to call a function, call it without saying anything else.\nIn case of a function error:\n- If this error stems from incorrect function parameters or syntax, you may retry with corrected arguments.\n- If the error's source is unclear or seems unrelated to your input, do not attempt further retries.\n") + (additionalInstructions ? "\n\n".concat(additionalInstructions) : "");
}
var Header = function Header() {
  var sortMessagesInPlace = function sortMessagesInPlace(messages) {
    messages.sort(function (a, b) {
      return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    });
    var seen = new Set();
    var result = [];
    var _iterator = _createForOfIteratorHelper(messages),
      _step;
    try {
      var _loop = function _loop() {
        var message = _step.value;
        if (seen.has(message.id)) return 1; // continue
        if (message.type === "ActionExecutionMessage") {
          result.push(message);
          seen.add(message.id);
          var resultMessage = messages.find(function (m) {
            return m.type === "ResultMessage" && m.actionExecutionId === message.id;
          });
          if (resultMessage && !seen.has(resultMessage.id)) {
            result.push(resultMessage);
            seen.add(resultMessage.id);
          }
        } else {
          result.push(message);
          seen.add(message.id);
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        if (_loop()) continue;
      }

      // Overwrite original array with result (in-place modification)
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    messages.length = 0;
    messages.push.apply(messages, result);
  };
  var _useChatContext = useChatContext(),
    labels = _useChatContext.labels;
  var chat = useCopilotChat();
  var messages = chat.visibleMessages || [];
  sortMessagesInPlace(messages);
  var setMessages = chat.setMessages;
  var _useState = useState(false),
    showNewChatModal = _useState[0],
    setShowNewChatModal = _useState[1];
  var _useStoreState2 = useStoreState(Store, function (s) {
      return {
        isDraggableModalMaximized: s.isDraggableModalMaximized
      };
    }),
    isDraggableModalMaximized = _useStoreState2.isDraggableModalMaximized;
  var _useState2 = useState(false),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  React.useEffect(function () {
    if (typeof window !== "undefined") {
      setIsMobile(window.matchMedia("(max-width: 639px)").matches);
    }
  }, []);
  var handleNewChat = function handleNewChat() {
    setShowNewChatModal(true);
  };
  var handleConfirmNewChat = function handleConfirmNewChat() {
    setMessages([]);
    setShowNewChatModal(false);
    trackEvent(MIXPANEL_EVENTS.LLM_MODAL_BUTTONS, {
      button_type: "new_chat",
      action: "click"
    });
  };
  var handleCancelNewChat = function handleCancelNewChat() {
    setShowNewChatModal(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "drag-handle cursor-move mt-1 flex items-center p-4 border-b border-teal-800 text-white shadow-[0_4px_24px_rgba(20,50,100,0.85)]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faRobot,
    size: "lg",
    className: "text-white p-1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ml-3 text-lg"
  }, labels.title)), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end items-center"
  }, messages.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "group flex items-center relative"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleNewChat,
    "aria-label": "New Chat",
    title: "New Chat",
    className: "group flex items-center text-white hover:text-gray-200 p-2 transition-all duration-200"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-2 text-base font-medium text-teal-400 whitespace-nowrap bg-white dark:bg-gray-900 px-3 py-1 rounded shadow-md border border-teal-200 dark:border-teal-700 z-10 transition-all duration-300 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0"
  }, "New Chat"), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faPlus,
    size: "sm"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "h-6 w-px bg-gray-600 mx-3"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-3"
  }, !isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.isDraggableModalMinimized = !s.isDraggableModalMinimized;
      });
      trackEvent(MIXPANEL_EVENTS.LLM_MODAL_BUTTONS, {
        button_type: "minimize",
        action: "click",
        is_minimized: !Store.getRawState().isDraggableModalMinimized
      });
    },
    "aria-label": "Minimize",
    title: "Minimize",
    className: "text-white hover:text-teal-400 p-1 px-2 rounded-full transition-all duration-200 hover:scale-110"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMinus,
    size: "sm"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.isDraggableModalMaximized = !s.isDraggableModalMaximized;
      });
      trackEvent(MIXPANEL_EVENTS.LLM_MODAL_BUTTONS, {
        button_type: "maximize",
        action: "click",
        is_maximized: !isDraggableModalMaximized
      });
    },
    "aria-label": "Maximize",
    title: "Maximize",
    className: "text-white hover:text-teal-400 p-1 px-2 rounded-full transition-all duration-200 hover:scale-110"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: isDraggableModalMaximized ? faWindowRestore : faWindowMaximize,
    size: "sm"
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.isDraggableModalOpen = !s.isDraggableModalOpen;
      });
      trackEvent(MIXPANEL_EVENTS.LLM_MODAL_BUTTONS, {
        button_type: "close",
        action: "click"
      });
    },
    "aria-label": "Close",
    title: "Close",
    className: "text-white hover:text-teal-400  p-1 px-2 rounded-full transition-all duration-200 hover:scale-120"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "sm"
  }))))), /*#__PURE__*/React.createElement(NewChatModal, {
    isOpen: showNewChatModal,
    onConfirm: handleConfirmNewChat,
    onCancel: handleCancelNewChat
  }));
};
export default CopilotWrapper;